import React from "react";
import CircularProgress, {
  CircularProgressProps,
} from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import "./CircularProgressBar.scss";

function CircularProgressBar(props: CircularProgressProps & { value: number }) {
  return (
    <Box
      className="box-wrapper"
      sx={{ position: "relative", display: "inline-flex" }}
    >
      <CircularProgress
        variant="determinate"
        thickness={5}
        {...props}
        className={"pw-foreground"}
      />
      <CircularProgress
        variant="determinate"
        value={100}
        className={"pw-background"}
        thickness={5}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
        >{`${
          (props.value < 1
            ? parseFloat(String(props.value)).toFixed(1)
            : Math.round(props.value)) + "%"
        }`}</Typography>
      </Box>
    </Box>
  );
}

export default CircularProgressBar;
